<template>
	<div class="content-wrapper">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item active">
					<i class="fa fa-home"></i>
					Dashboard
				</li>
			</ol>
		</nav>

		<div class="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-header">
								<strong>{{ report }}</strong>
							</div>
							<vue-cal @ready="display" @view-change="display" @event-click="handleEventClick"
								:time="false" view="month" :events="events" events-on-month-view="short"
								:disable-views="['week', 'day']">
								<template #event-content="{ event }">
									<div class="custom-event"
										:style="{ backgroundColor: '#ff0000 !important', color: '#fff !important' }">
										<i class="mdi mdi-account"></i>
										<strong>{{ event.title }}</strong>
									</div>
								</template>
							</vue-cal>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'

export default {
	name: "SessionSummaryCalendar",
	components: { VueCal },
	data() {
		const now = new Date();
		const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
		const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
		return {
			report: "Dashboard",
			session: {
				branch_id: this.$store.getters.user?.branch_id,
				start: startOfMonth.toISOString().split("T")[0],
				end: endOfMonth.toISOString().split("T")[0],
			},
			events: [],
			errors: [],
		};
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => vm.getSessionSummaries());
	},
	methods: {
		getSessionSummaries() {
			this.$store
				.dispatch("post", {
					uri: "getSessionSummaries",
					data: this.session,
				})
				.then((response) => {
					this.events = response.data.data.map((item) => {
						const startDate = new Date(item.start);
						const endDate = new Date(item.end);

						const formatTime = (date) => date.toTimeString().slice(0, 5);

						const timeRange = `${formatTime(startDate)} - ${formatTime(endDate)}`;

						return {
							...item,
							start: item.start,
							end: item.end,
							title: ` ${item.title || "Untitled"} (${timeRange})`,
							color: item.color || "#000000",
							session_log_id: item.session_log_id,
						};
					});
				})

				.catch((error) => {
					this.errors = error.response?.data?.errors || [];
					this.$store.dispatch("error", error.response?.data?.message || "Error loading sessions");
				});
		},

		display({ startDate, endDate }) {
			this.session.start = new Date(startDate).toISOString().split("T")[0];
			this.session.end = new Date(endDate).toISOString().split("T")[0];
			this.getSessionSummaries();
		},

		handleEventClick(event) {
			if (!event.session_log_id) {
				console.warn("Missing session_log_id in event", event);
				this.$store.dispatch("error", "Session log ID not found.");
				return;
			}
			this.downloadSessionReport(event.session_log_id);
		},

		downloadSessionReport(session_log_id) {
			const branch_id = this.session.branch_id;
			const apiUrl = this.$store.state.apiUrl;

			const downloadUrl = `${apiUrl}getSessionReportDownload?branch_id=${branch_id}&session_log_id=${session_log_id}`;

			window.location.href = downloadUrl;
		},
	},
};
</script>

<style scoped>
.vuecal {
	height: 600px;
}

.custom-event {
	padding: 4px 6px;
	border-radius: 4px;
	font-size: 12px;
	font-weight: bold;
	text-align: center;
	width: 100%;
	box-sizing: border-box;
	white-space: normal !important;
	overflow: visible !important;
	cursor: pointer;
	pointer-events: auto;
}

.vuecal--month-view .vuecal__cell {
	height: 80px;
}

.vuecal--month-view .vuecal__cell-content {
	justify-content: flex-start;
	height: 100%;
	align-items: flex-end;
}

.vuecal--month-view .vuecal__cell-date {
	padding: 4px;
}

.vuecal--month-view .vuecal__no-event {
	display: none;
}

.red-event {
	background-color: red !important;
	color: white;
}
</style>
